export const NO_CONTACT_INFO = 'Sem info do contato'

const isObject = (value) => Boolean(value) && typeof value === 'object'

const parseInfoJSON = (info) => {
  try {
    const parsed = JSON.parse(info)
    return isObject(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const parseContactInfo = (info) => {
  if (!info) return null
  if (isObject(info)) return info
  return parseInfoJSON(info)
}

export const contactDisplayName = (info) => {
  const contactInfo = parseContactInfo(info)
  if (!contactInfo) return null

  return `${contactInfo.firstName ?? ''} ${contactInfo.lastName ?? ''}`.trim() || null
}

export const contactInfoTooltip = (info) => {
  const name = contactDisplayName(info)
  if (!name) return NO_CONTACT_INFO

  return `Info do contato: ${name}`
}
